import { render } from "./UserForm.vue?vue&type=template&id=df77f5a2&scoped=true&ts=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"

import "./UserForm.vue?vue&type=style&index=0&id=df77f5a2&lang=scss&scoped=true"

import exportComponent from "/home/klaus/Dokumente/Projekte/Hochzeit/wedding-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df77f5a2"]])

export default __exports__